"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kinaseInfo = exports.kinaseGroupNames = void 0;
/**
 * Known Kinase Group Names
 */
var kinaseGroupNames = exports.kinaseGroupNames = ['Atypical', 'AGC', 'CAMK', 'CK1', 'CMGC', 'Other', 'RGC', 'STE', 'TK', 'TKL'];

/**
 * Information about each kinase. Currently just group name.
 */
var kinaseInfo = exports.kinaseInfo = {
  ADCK1: {
    group: 'Atypical'
  },
  ADCK5: {
    group: 'Atypical'
  },
  ADCK3: {
    group: 'Atypical'
  },
  ADCK4: {
    group: 'Atypical'
  },
  ADCK2: {
    group: 'Atypical'
  },
  ChaK1: {
    group: 'Atypical'
  },
  ChaK2: {
    group: 'Atypical'
  },
  AlphaK3: {
    group: 'Atypical'
  },
  eEF2K: {
    group: 'Atypical'
  },
  AlphaK2: {
    group: 'Atypical'
  },
  AlphaK1: {
    group: 'Atypical'
  },
  BRD2: {
    group: 'Atypical'
  },
  BRD3: {
    group: 'Atypical'
  },
  BRD4: {
    group: 'Atypical'
  },
  BRDT: {
    group: 'Atypical'
  },
  PDHK2: {
    group: 'Atypical'
  },
  PDHK3: {
    group: 'Atypical'
  },
  PDHK1: {
    group: 'Atypical'
  },
  PDHK4: {
    group: 'Atypical'
  },
  ATR: {
    group: 'Atypical'
  },
  FRAP: {
    group: 'Atypical'
  },
  DNAPK: {
    group: 'Atypical'
  },
  SMG1: {
    group: 'Atypical'
  },
  TRRAP: {
    group: 'Atypical'
  },
  RIOK3: {
    group: 'Atypical'
  },
  RIOK1: {
    group: 'Atypical'
  },
  RIOK2: {
    group: 'Atypical'
  },
  TIF1a: {
    group: 'Atypical'
  },
  TIF1g: {
    group: 'Atypical'
  },
  TIF1b: {
    group: 'Atypical'
  },
  ATM: {
    group: 'Atypical'
  },
  BCKDK: {
    group: 'Atypical'
  },
  AAK1: {
    group: 'Other'
  },
  ABL1: {
    group: 'TK'
  },
  ABL2: {
    group: 'TK'
  },
  ACK: {
    group: 'TK'
  },
  ACTR2: {
    group: 'TKL'
  },
  ACTR2B: {
    group: 'TKL'
  },
  AKT1: {
    group: 'AGC'
  },
  AKT2: {
    group: 'AGC'
  },
  AKT3: {
    group: 'AGC'
  },
  ALK: {
    group: 'TK'
  },
  ALK1: {
    group: 'TKL'
  },
  ALK2: {
    group: 'TKL'
  },
  ALK4: {
    group: 'TKL'
  },
  ALK7: {
    group: 'TKL'
  },
  AMPKa1: {
    group: 'CAMK'
  },
  AMPKa2: {
    group: 'CAMK'
  },
  ANKRD3: {
    group: 'TKL'
  },
  ANPa: {
    group: 'RGC'
  },
  ANPb: {
    group: 'RGC'
  },
  ARAF: {
    group: 'TKL'
  },
  AurA: {
    group: 'Other'
  },
  AurB: {
    group: 'Other'
  },
  AurC: {
    group: 'Other'
  },
  AXL: {
    group: 'TK'
  },
  BARK1: {
    group: 'AGC'
  },
  BARK2: {
    group: 'AGC'
  },
  BIKE: {
    group: 'Other'
  },
  BLK: {
    group: 'TK'
  },
  BMPR1A: {
    group: 'TKL'
  },
  BMPR1B: {
    group: 'TKL'
  },
  BMPR2: {
    group: 'TKL'
  },
  BMX: {
    group: 'TK'
  },
  BRAF: {
    group: 'TKL'
  },
  BRK: {
    group: 'TK'
  },
  BRSK1: {
    group: 'CAMK'
  },
  BRSK2: {
    group: 'CAMK'
  },
  BTK: {
    group: 'TK'
  },
  BUB1: {
    group: 'Other'
  },
  BUBR1: {
    group: 'Other'
  },
  CaMK1a: {
    group: 'CAMK'
  },
  CaMK1b: {
    group: 'CAMK'
  },
  CaMK1d: {
    group: 'CAMK'
  },
  CaMK1g: {
    group: 'CAMK'
  },
  CaMK2a: {
    group: 'CAMK'
  },
  CaMK2b: {
    group: 'CAMK'
  },
  CaMK2d: {
    group: 'CAMK'
  },
  CaMK2g: {
    group: 'CAMK'
  },
  CaMK4: {
    group: 'CAMK'
  },
  CaMKK1: {
    group: 'Other'
  },
  CaMKK2: {
    group: 'Other'
  },
  caMLCK: {
    group: 'CAMK'
  },
  CASK: {
    group: 'CAMK'
  },
  CCK4: {
    group: 'TK'
  },
  CCRK: {
    group: 'CMGC'
  },
  CDC2: {
    group: 'CMGC'
  },
  CDC7: {
    group: 'Other'
  },
  CDK10: {
    group: 'CMGC'
  },
  CDK11: {
    group: 'CMGC'
  },
  CDK2: {
    group: 'CMGC'
  },
  CDK3: {
    group: 'CMGC'
  },
  CDK4: {
    group: 'CMGC'
  },
  CDK5: {
    group: 'CMGC'
  },
  CDK6: {
    group: 'CMGC'
  },
  CDK7: {
    group: 'CMGC'
  },
  CDK8: {
    group: 'CMGC'
  },
  CDK9: {
    group: 'CMGC'
  },
  CDKL1: {
    group: 'CMGC'
  },
  CDKL2: {
    group: 'CMGC'
  },
  CDKL3: {
    group: 'CMGC'
  },
  CDKL4: {
    group: 'CMGC'
  },
  CDKL5: {
    group: 'CMGC'
  },
  CHED: {
    group: 'CMGC'
  },
  CHK1: {
    group: 'CAMK'
  },
  CHK2: {
    group: 'CAMK'
  },
  CK1a: {
    group: 'CK1'
  },
  CK1a2: {
    group: 'CK1'
  },
  CK1d: {
    group: 'CK1'
  },
  CK1e: {
    group: 'CK1'
  },
  CK1g1: {
    group: 'CK1'
  },
  CK1g2: {
    group: 'CK1'
  },
  CK1g3: {
    group: 'CK1'
  },
  CK2a1: {
    group: 'CMGC'
  },
  CK2a2: {
    group: 'CMGC'
  },
  CLIK1: {
    group: 'Other'
  },
  CLIK1L: {
    group: 'Other'
  },
  CLK1: {
    group: 'CMGC'
  },
  CLK2: {
    group: 'CMGC'
  },
  CLK3: {
    group: 'CMGC'
  },
  CLK4: {
    group: 'CMGC'
  },
  COT: {
    group: 'STE'
  },
  CRIK: {
    group: 'AGC'
  },
  CRK7: {
    group: 'CMGC'
  },
  CSK: {
    group: 'TK'
  },
  CTK: {
    group: 'TK'
  },
  CYGD: {
    group: 'RGC'
  },
  CYGF: {
    group: 'RGC'
  },
  DAPK1: {
    group: 'CAMK'
  },
  DAPK2: {
    group: 'CAMK'
  },
  DAPK3: {
    group: 'CAMK'
  },
  DCAMKL1: {
    group: 'CAMK'
  },
  DCAMKL2: {
    group: 'CAMK'
  },
  DCAMKL3: {
    group: 'CAMK'
  },
  DDR1: {
    group: 'TK'
  },
  DDR2: {
    group: 'TK'
  },
  DLK: {
    group: 'TKL'
  },
  DMPK1: {
    group: 'AGC'
  },
  DMPK2: {
    group: 'AGC'
  },
  DRAK1: {
    group: 'CAMK'
  },
  DRAK2: {
    group: 'CAMK'
  },
  DYRK1A: {
    group: 'CMGC'
  },
  DYRK1B: {
    group: 'CMGC'
  },
  DYRK2: {
    group: 'CMGC'
  },
  DYRK3: {
    group: 'CMGC'
  },
  DYRK4: {
    group: 'CMGC'
  },
  EGFR: {
    group: 'TK'
  },
  EphA1: {
    group: 'TK'
  },
  EphA10: {
    group: 'TK'
  },
  EphA2: {
    group: 'TK'
  },
  EphA3: {
    group: 'TK'
  },
  EphA4: {
    group: 'TK'
  },
  EphA5: {
    group: 'TK'
  },
  EphA6: {
    group: 'TK'
  },
  EphA7: {
    group: 'TK'
  },
  EphA8: {
    group: 'TK'
  },
  EphB1: {
    group: 'TK'
  },
  EphB2: {
    group: 'TK'
  },
  EphB3: {
    group: 'TK'
  },
  EphB4: {
    group: 'TK'
  },
  EphB6: {
    group: 'TK'
  },
  ErbB2: {
    group: 'TK'
  },
  ErbB3: {
    group: 'TK'
  },
  ErbB4: {
    group: 'TK'
  },
  Erk1: {
    group: 'CMGC'
  },
  Erk2: {
    group: 'CMGC'
  },
  Erk3: {
    group: 'CMGC'
  },
  Erk4: {
    group: 'CMGC'
  },
  Erk5: {
    group: 'CMGC'
  },
  Erk7: {
    group: 'CMGC'
  },
  FAK: {
    group: 'TK'
  },
  FER: {
    group: 'TK'
  },
  FES: {
    group: 'TK'
  },
  FGFR1: {
    group: 'TK'
  },
  FGFR2: {
    group: 'TK'
  },
  FGFR3: {
    group: 'TK'
  },
  FGFR4: {
    group: 'TK'
  },
  FGR: {
    group: 'TK'
  },
  FLT1: {
    group: 'TK'
  },
  FLT3: {
    group: 'TK'
  },
  FLT4: {
    group: 'TK'
  },
  FMS: {
    group: 'TK'
  },
  FRK: {
    group: 'TK'
  },
  Fused: {
    group: 'Other'
  },
  FYN: {
    group: 'TK'
  },
  GAK: {
    group: 'Other'
  },
  GCK: {
    group: 'STE'
  },
  GCN2: {
    group: 'Other'
  },
  GCN2_b: {
    group: 'STE'
  },
  GPRK4: {
    group: 'AGC'
  },
  GPRK5: {
    group: 'AGC'
  },
  GPRK6: {
    group: 'AGC'
  },
  GPRK7: {
    group: 'AGC'
  },
  GSK3A: {
    group: 'CMGC'
  },
  GSK3B: {
    group: 'CMGC'
  },
  Haspin: {
    group: 'Other'
  },
  HCK: {
    group: 'TK'
  },
  HGK: {
    group: 'STE'
  },
  HH498: {
    group: 'TKL'
  },
  HIPK1: {
    group: 'CMGC'
  },
  HIPK2: {
    group: 'CMGC'
  },
  HIPK3: {
    group: 'CMGC'
  },
  HIPK4: {
    group: 'CMGC'
  },
  HPK1: {
    group: 'STE'
  },
  HRI: {
    group: 'Other'
  },
  HSER: {
    group: 'RGC'
  },
  HUNK: {
    group: 'CAMK'
  },
  ICK: {
    group: 'CMGC'
  },
  IGF1R: {
    group: 'TK'
  },
  IKKa: {
    group: 'Other'
  },
  IKKb: {
    group: 'Other'
  },
  IKKe: {
    group: 'Other'
  },
  ILK: {
    group: 'TKL'
  },
  INSR: {
    group: 'TK'
  },
  IRAK1: {
    group: 'TKL'
  },
  IRAK2: {
    group: 'TKL'
  },
  IRAK3: {
    group: 'TKL'
  },
  IRAK4: {
    group: 'TKL'
  },
  IRE1: {
    group: 'Other'
  },
  IRE2: {
    group: 'Other'
  },
  IRR: {
    group: 'TK'
  },
  ITK: {
    group: 'TK'
  },
  JAK1: {
    group: 'TK'
  },
  JAK1_b: {
    group: 'TK'
  },
  JAK2: {
    group: 'TK'
  },
  JAK2_b: {
    group: 'TK'
  },
  JAK3: {
    group: 'TK'
  },
  JAK3_b: {
    group: 'TK'
  },
  JNK1: {
    group: 'CMGC'
  },
  JNK2: {
    group: 'CMGC'
  },
  JNK3: {
    group: 'CMGC'
  },
  KDR: {
    group: 'TK'
  },
  KHS1: {
    group: 'STE'
  },
  KHS2: {
    group: 'STE'
  },
  KIS: {
    group: 'Other'
  },
  KIT: {
    group: 'TK'
  },
  KSR1: {
    group: 'TKL'
  },
  KSR2: {
    group: 'TKL'
  },
  LATS1: {
    group: 'AGC'
  },
  LATS2: {
    group: 'AGC'
  },
  LCK: {
    group: 'TK'
  },
  LIMK1: {
    group: 'TKL'
  },
  LIMK2: {
    group: 'TKL'
  },
  LKB1: {
    group: 'CAMK'
  },
  LMR1: {
    group: 'TK'
  },
  LMR2: {
    group: 'TK'
  },
  LMR3: {
    group: 'TK'
  },
  LOK: {
    group: 'STE'
  },
  LRRK1: {
    group: 'TKL'
  },
  LRRK2: {
    group: 'TKL'
  },
  LTK: {
    group: 'TK'
  },
  LYN: {
    group: 'TK'
  },
  LZK: {
    group: 'TKL'
  },
  MAK: {
    group: 'CMGC'
  },
  MAP2K1: {
    group: 'STE'
  },
  MAP2K2: {
    group: 'STE'
  },
  MAP2K3: {
    group: 'STE'
  },
  MAP2K4: {
    group: 'STE'
  },
  MAP2K5: {
    group: 'STE'
  },
  MAP2K6: {
    group: 'STE'
  },
  MAP2K7: {
    group: 'STE'
  },
  MAP3K1: {
    group: 'STE'
  },
  MAP3K19: {
    group: 'STE'
  },
  MAP3K2: {
    group: 'STE'
  },
  MAP3K3: {
    group: 'STE'
  },
  MAP3K4: {
    group: 'STE'
  },
  MAP3K5: {
    group: 'STE'
  },
  MAP3K6: {
    group: 'STE'
  },
  MAP3K7: {
    group: 'STE'
  },
  MAPKAPK2: {
    group: 'CAMK'
  },
  MAPKAPK3: {
    group: 'CAMK'
  },
  MAPKAPK5: {
    group: 'CAMK'
  },
  MARK1: {
    group: 'CAMK'
  },
  MARK2: {
    group: 'CAMK'
  },
  MARK3: {
    group: 'CAMK'
  },
  MARK4: {
    group: 'CAMK'
  },
  MAST1: {
    group: 'AGC'
  },
  MAST2: {
    group: 'AGC'
  },
  MAST3: {
    group: 'AGC'
  },
  MAST4: {
    group: 'AGC'
  },
  MASTL: {
    group: 'AGC'
  },
  MELK: {
    group: 'CAMK'
  },
  MER: {
    group: 'TK'
  },
  MET: {
    group: 'TK'
  },
  MINK: {
    group: 'STE'
  },
  MISR2: {
    group: 'TKL'
  },
  MLK1: {
    group: 'TKL'
  },
  MLK2: {
    group: 'TKL'
  },
  MLK3: {
    group: 'TKL'
  },
  MLK4: {
    group: 'TKL'
  },
  MLKL: {
    group: 'TKL'
  },
  MNK1: {
    group: 'CAMK'
  },
  MNK2: {
    group: 'CAMK'
  },
  MOK: {
    group: 'CMGC'
  },
  MOS: {
    group: 'Other'
  },
  MPSK1: {
    group: 'Other'
  },
  MRCKa: {
    group: 'AGC'
  },
  MRCKb: {
    group: 'AGC'
  },
  MSK1: {
    group: 'AGC'
  },
  MSK1_b: {
    group: 'CAMK'
  },
  MSK2: {
    group: 'AGC'
  },
  MSK2_b: {
    group: 'CAMK'
  },
  MSSK1: {
    group: 'CMGC'
  },
  MST1: {
    group: 'STE'
  },
  MST2: {
    group: 'STE'
  },
  MST3: {
    group: 'STE'
  },
  MST4: {
    group: 'STE'
  },
  MUSK: {
    group: 'TK'
  },
  MYO3A: {
    group: 'STE'
  },
  MYO3B: {
    group: 'STE'
  },
  MYT1: {
    group: 'Other'
  },
  NDR1: {
    group: 'AGC'
  },
  NDR2: {
    group: 'AGC'
  },
  NEK1: {
    group: 'Other'
  },
  NEK10: {
    group: 'Other'
  },
  NEK11: {
    group: 'Other'
  },
  NEK2: {
    group: 'Other'
  },
  NEK3: {
    group: 'Other'
  },
  NEK4: {
    group: 'Other'
  },
  NEK5: {
    group: 'Other'
  },
  NEK6: {
    group: 'Other'
  },
  NEK7: {
    group: 'Other'
  },
  NEK8: {
    group: 'Other'
  },
  NEK9: {
    group: 'Other'
  },
  NIK: {
    group: 'STE'
  },
  NIM1: {
    group: 'CAMK'
  },
  NLK: {
    group: 'CMGC'
  },
  NRBP1: {
    group: 'Other'
  },
  NRBP2: {
    group: 'Other'
  },
  NRK: {
    group: 'STE'
  },
  NuaK1: {
    group: 'CAMK'
  },
  NuaK2: {
    group: 'CAMK'
  },
  Obscn: {
    group: 'CAMK'
  },
  Obscn_b: {
    group: 'CAMK'
  },
  OSR1: {
    group: 'STE'
  },
  p38a: {
    group: 'CMGC'
  },
  p38b: {
    group: 'CMGC'
  },
  p38d: {
    group: 'CMGC'
  },
  p38g: {
    group: 'CMGC'
  },
  p70S6K: {
    group: 'AGC'
  },
  p70S6Kb: {
    group: 'AGC'
  },
  PAK1: {
    group: 'STE'
  },
  PAK2: {
    group: 'STE'
  },
  PAK3: {
    group: 'STE'
  },
  PAK4: {
    group: 'STE'
  },
  PAK5: {
    group: 'STE'
  },
  PAK6: {
    group: 'STE'
  },
  PASK: {
    group: 'CAMK'
  },
  PBK: {
    group: 'Other'
  },
  PCTAIRE1: {
    group: 'CMGC'
  },
  PCTAIRE2: {
    group: 'CMGC'
  },
  PCTAIRE3: {
    group: 'CMGC'
  },
  PDGFRa: {
    group: 'TK'
  },
  PDGFRb: {
    group: 'TK'
  },
  PDK1: {
    group: 'AGC'
  },
  PEK: {
    group: 'Other'
  },
  PFTAIRE1: {
    group: 'CMGC'
  },
  PFTAIRE2: {
    group: 'CMGC'
  },
  PHKg1: {
    group: 'CAMK'
  },
  PHKg2: {
    group: 'CAMK'
  },
  PIK3R4: {
    group: 'Other'
  },
  PIM1: {
    group: 'CAMK'
  },
  PIM2: {
    group: 'CAMK'
  },
  PIM3: {
    group: 'CAMK'
  },
  PINK1: {
    group: 'Other'
  },
  PITSLRE: {
    group: 'CMGC'
  },
  PKACa: {
    group: 'AGC'
  },
  PKACb: {
    group: 'AGC'
  },
  PKACg: {
    group: 'AGC'
  },
  PKCa: {
    group: 'AGC'
  },
  PKCb: {
    group: 'AGC'
  },
  PKCd: {
    group: 'AGC'
  },
  PKCe: {
    group: 'AGC'
  },
  PKCg: {
    group: 'AGC'
  },
  PKCh: {
    group: 'AGC'
  },
  PKCi: {
    group: 'AGC'
  },
  PKCt: {
    group: 'AGC'
  },
  PKCz: {
    group: 'AGC'
  },
  PKD1: {
    group: 'CAMK'
  },
  PKD2: {
    group: 'CAMK'
  },
  PKD3: {
    group: 'CAMK'
  },
  PKG1: {
    group: 'AGC'
  },
  PKG2: {
    group: 'AGC'
  },
  PKN1: {
    group: 'AGC'
  },
  PKN2: {
    group: 'AGC'
  },
  PKN3: {
    group: 'AGC'
  },
  PKR: {
    group: 'Other'
  },
  PLK1: {
    group: 'Other'
  },
  PLK2: {
    group: 'Other'
  },
  PLK3: {
    group: 'Other'
  },
  PLK4: {
    group: 'Other'
  },
  PRKX: {
    group: 'AGC'
  },
  PRKY: {
    group: 'AGC'
  },
  PRP4: {
    group: 'CMGC'
  },
  PRPK: {
    group: 'Other'
  },
  PSKH1: {
    group: 'CAMK'
  },
  PSKH2: {
    group: 'CAMK'
  },
  PYK2: {
    group: 'TK'
  },
  QIK: {
    group: 'CAMK'
  },
  QSK: {
    group: 'CAMK'
  },
  RAF1: {
    group: 'TKL'
  },
  RET: {
    group: 'TK'
  },
  RHOK: {
    group: 'AGC'
  },
  RIPK1: {
    group: 'TKL'
  },
  RIPK2: {
    group: 'TKL'
  },
  RIPK3: {
    group: 'TKL'
  },
  RNAseL: {
    group: 'Other'
  },
  ROCK1: {
    group: 'AGC'
  },
  ROCK2: {
    group: 'AGC'
  },
  RON: {
    group: 'TK'
  },
  ROR1: {
    group: 'TK'
  },
  ROR2: {
    group: 'TK'
  },
  ROS: {
    group: 'TK'
  },
  RSK1: {
    group: 'AGC'
  },
  RSK1_b: {
    group: 'CAMK'
  },
  RSK2: {
    group: 'AGC'
  },
  RSK2_b: {
    group: 'CAMK'
  },
  RSK3: {
    group: 'AGC'
  },
  RSK3_b: {
    group: 'CAMK'
  },
  RSK4: {
    group: 'AGC'
  },
  RSK4_b: {
    group: 'CAMK'
  },
  RSKL1: {
    group: 'AGC'
  },
  RSKL2: {
    group: 'AGC'
  },
  RYK: {
    group: 'TK'
  },
  SBK: {
    group: 'Other'
  },
  SCYL1: {
    group: 'Other'
  },
  SCYL2: {
    group: 'Other'
  },
  SCYL3: {
    group: 'Other'
  },
  SgK069: {
    group: 'Other'
  },
  SgK071: {
    group: 'Other'
  },
  SgK085: {
    group: 'CAMK'
  },
  SGK1: {
    group: 'AGC'
  },
  SgK110: {
    group: 'Other'
  },
  SgK196: {
    group: 'Other'
  },
  SGK2: {
    group: 'AGC'
  },
  SgK223: {
    group: 'Other'
  },
  SgK269: {
    group: 'Other'
  },
  SgK288: {
    group: 'TKL'
  },
  SGK3: {
    group: 'AGC'
  },
  SgK307: {
    group: 'Other'
  },
  SgK396: {
    group: 'Other'
  },
  SgK424: {
    group: 'Other'
  },
  SgK493: {
    group: 'Other'
  },
  SgK494: {
    group: 'AGC'
  },
  SgK495: {
    group: 'CAMK'
  },
  SgK496: {
    group: 'Other'
  },
  SIK: {
    group: 'CAMK'
  },
  skMLCK: {
    group: 'CAMK'
  },
  SLK: {
    group: 'STE'
  },
  Slob: {
    group: 'Other'
  },
  smMLCK: {
    group: 'CAMK'
  },
  SNRK: {
    group: 'CAMK'
  },
  SPEG: {
    group: 'CAMK'
  },
  SPEG_b: {
    group: 'CAMK'
  },
  SRC: {
    group: 'TK'
  },
  SRM: {
    group: 'TK'
  },
  SRPK1: {
    group: 'CMGC'
  },
  SRPK2: {
    group: 'CMGC'
  },
  SSTK: {
    group: 'CAMK'
  },
  STK33: {
    group: 'CAMK'
  },
  STLK3: {
    group: 'STE'
  },
  STLK5: {
    group: 'STE'
  },
  STLK6: {
    group: 'STE'
  },
  SuRTK106: {
    group: 'TK'
  },
  SYK: {
    group: 'TK'
  },
  TAK1: {
    group: 'TKL'
  },
  TAO1: {
    group: 'STE'
  },
  TAO2: {
    group: 'STE'
  },
  TAO3: {
    group: 'STE'
  },
  TBCK: {
    group: 'Other'
  },
  TBK1: {
    group: 'Other'
  },
  TEC: {
    group: 'TK'
  },
  TESK1: {
    group: 'TKL'
  },
  TESK2: {
    group: 'TKL'
  },
  TGFbR1: {
    group: 'TKL'
  },
  TGFbR2: {
    group: 'TKL'
  },
  TIE1: {
    group: 'TK'
  },
  TIE2: {
    group: 'TK'
  },
  TLK1: {
    group: 'Other'
  },
  TLK2: {
    group: 'Other'
  },
  TNIK: {
    group: 'STE'
  },
  TNK1: {
    group: 'TK'
  },
  Trad: {
    group: 'CAMK'
  },
  Trb1: {
    group: 'CAMK'
  },
  Trb2: {
    group: 'CAMK'
  },
  Trb3: {
    group: 'CAMK'
  },
  Trio: {
    group: 'CAMK'
  },
  TRKA: {
    group: 'TK'
  },
  TRKB: {
    group: 'TK'
  },
  TRKC: {
    group: 'TK'
  },
  TSSK1: {
    group: 'CAMK'
  },
  TSSK2: {
    group: 'CAMK'
  },
  TSSK3: {
    group: 'CAMK'
  },
  TSSK4: {
    group: 'CAMK'
  },
  TTBK1: {
    group: 'CK1'
  },
  TTBK2: {
    group: 'CK1'
  },
  TTK: {
    group: 'Other'
  },
  TTN: {
    group: 'CAMK'
  },
  TXK: {
    group: 'TK'
  },
  TYK2: {
    group: 'TK'
  },
  TYK2_b: {
    group: 'TK'
  },
  TYRO3: {
    group: 'TK'
  },
  ULK1: {
    group: 'Other'
  },
  ULK2: {
    group: 'Other'
  },
  ULK3: {
    group: 'Other'
  },
  ULK4: {
    group: 'Other'
  },
  VACAMKL: {
    group: 'CAMK'
  },
  VRK1: {
    group: 'CK1'
  },
  VRK2: {
    group: 'CK1'
  },
  VRK3: {
    group: 'CK1'
  },
  Wee1: {
    group: 'Other'
  },
  Wee1B: {
    group: 'Other'
  },
  Wnk1: {
    group: 'Other'
  },
  Wnk2: {
    group: 'Other'
  },
  Wnk3: {
    group: 'Other'
  },
  Wnk4: {
    group: 'Other'
  },
  YANK1: {
    group: 'AGC'
  },
  YANK2: {
    group: 'AGC'
  },
  YANK3: {
    group: 'AGC'
  },
  YES: {
    group: 'TK'
  },
  YSK1: {
    group: 'STE'
  },
  ZAK: {
    group: 'TKL'
  },
  ZAP70: {
    group: 'TK'
  }
};